import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { AuthProvider, AuthContext } from './contexts/AuthContext';
import Main from './Main';
import Auth from './components/Auth';
import ErrorBoundary from './components/ErrorBoundary';
import DataTable from '@preflighttech/preflight-tables';

const TABLE_STYLES = {
  data: {
    cell: {
      fontFamily: 'sans-serif',
      fontSize: 14,
    }
  },
};

const App = () => {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <DataTable.Provider
          htmlTable
          lengthMenu={ [10, 25, 50, 'All'] }
          pageLength={25}
          styles={TABLE_STYLES}
        >
          <AuthProvider>
            <AuthContext.Consumer>
              {ctx => (ctx.isLoggedIn) ? (
                <ErrorBoundary>
                  {ctx.apolloClient && <Main />}
                </ErrorBoundary>
              ) : (
                <ErrorBoundary>
                  <Auth />
                </ErrorBoundary>
              )}
            </AuthContext.Consumer>

            <Toaster />
          </AuthProvider>
        </DataTable.Provider>
      </ErrorBoundary>
    </HelmetProvider>
  );
};

export default App;
